import { Fragment } from "react";
import { Badge, Col, Row } from "reactstrap";
import { Href } from "../../../../../Constants/Constants";
import { PhotosChatData } from "../../../../../Data/Messenger/Messenger";
import { dynamicImage, Image } from "../../../../../Utils";
import SvgIcon from "../../../../CommonComponents/SvgIcon";

const PhotosChat = () => {
  return (
    <Fragment>
      <div className="gallery-img-group">
        <Row>
          {PhotosChatData.map((item, index) => (
            <Col xs="6" key={index}>
              <Image className={`img-fluid img-100 gallery-group-${item.class}`}src={dynamicImage(`gallery/${item.image}.jpg`)} alt="Avatar" />
              <Image className={`img-fluid img-100 gallery-group-${item.avatarClass}`}src={dynamicImage(`gallery/${item.avatar}.jpg`)} alt="Avatar" />
            </Col>
          ))}
        </Row>
        <div className="gallery-spinner">
          <div className="icon-btns">
            <a href={Href}>
              <h4><SvgIcon iconId="document-download" />53 MB</h4>
            </a>
          </div>
        </div>
      </div>
      <h4>You understand</h4>
      <Badge color="white" className="badge-img sm">😍</Badge>
    </Fragment>
  );
};

export default PhotosChat;
